import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface TagProps {
    children: ReactNode
    className?: string
    tone?: 'default' | 'brand'
}

/** Small bordered mono label for topics and tags. */
const Tag: FC<TagProps> = ({ children, className, tone = 'default' }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[0.6875rem] uppercase leading-5 tracking-[0.06em]',
                tone === 'brand' ? 'border-brand text-brand' : 'border-border text-muted-foreground',
                className
            )}
        >
            {children}
        </span>
    )
}

export default Tag
